export function formatMoneyValue(value: number) {
  return `${Math.floor(value / 100)}.${value % 100 < 10 ? `0${value % 100}` : value % 100}`;
}

// i18n certified - complete
